import Opsleads from "../../../jsx/components/Dashboard/OpsLeads/opsleads";

const OpsLeadsWrapper = () => {
  return <Opsleads />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.telecaller];

export default constore(OpsLeadsWrapper);
